import { useMemo, useState } from "react";

import Pager from "../components/Pager";
import {DEFAULT_PAGE_LIMIT} from "../globals/constants";

export const useSimplePagination = () => {
	const [ pageNumber, setPageNumber ] = useState(1);
	const [ pageLimit, setPageLimit ] = useState(DEFAULT_PAGE_LIMIT);
	const pageOffset = useMemo(() => Pager.pageOffsetByPageNumber(pageNumber), [ pageNumber ]);

	return {
		pageLimit,
		pageOffset,
		pageNumber,
		setPageLimit,
		setPageNumber
	};
};

export default useSimplePagination;